// angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  computed,
} from "@angular/core";
import { FormGroup } from "@angular/forms";

//ngx-quill imports
import Quill from 'quill';

//image resizer plugin for ngx-quill
import ImageResizor from 'quill-image-resizor';

//table plugin for ngx-quill
import TableUp, {
  defaultCustomSelect,
  TableMenuSelect,
  TableResizeLine,
  TableResizeScale,
  TableSelection,
  TableVirtualScrollbar,
} from 'quill-table-up';

// Bind Quill instance to ImageResizor plugin
ImageResizor.Quill = Quill

// Register ImageResizor and TableUp module with Quill
Quill.register('modules/imageResizor', ImageResizor);
Quill.register({ [`modules/${TableUp.moduleName}`]: TableUp }, true);

@Component({
  selector: "rich-text-input",
  standalone: false,
  templateUrl: "./rich-text-input.component.html",
  styleUrl: "./rich-text-input.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextInputComponent {
  public form = input.required<FormGroup>();
  public id = input.required<string>();
  public readOnly = input<boolean>(false);
  public bgClass = input<string>();
  public placeholder = input<string>();
  public toolbar = input<any[]>();
  public onContentChanged = output();
  public onEditorChanged = output();

  // Default toolbar configuration
  private defaultToolbar = [
    ["bold", "italic", "underline", "strike"],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': [] }],
    [{ 'align': [] }],
    [{ 'color': [] }, { 'background': [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ['clean'],
    ['link' , 'image'],
    [{ [TableUp.toolName]: [] }]
  ];

  public modules = computed(() => {
    const toolbarConfig = this.toolbar() || this.defaultToolbar;
    return !this.readOnly() ? { table: false, imageResizor: {},  toolbar: toolbarConfig,     [TableUp.moduleName]: {
      scrollbar: TableVirtualScrollbar,
      resize: TableResizeLine,
      resizeScale: TableResizeScale,
      customSelect: defaultCustomSelect,
      selection: TableSelection,
      selectionOptions: {
        tableMenu: TableMenuSelect,
      },
    }, } : { toolbar: null };
  });
}